import GlicLogo from './GlicLogo';

export default GlicLogo;
